import React from "react";

import { AdBanner } from "Components/atoms/AdBanner";

import { AdBannerFooterContainerProps } from "../types";
import { Container } from "./styles";

import { theme } from "styles/theme";
import { GoogleBannerAd } from "../../GoogleAds/GoogleBannerAd";

/**
 * Componente AdBannerFooterContainerDesktop
 *
 * Contêiner para exibir um banner de anúncio centralizado.
 *
 * @param adUnit - Unidade de anúncio do GPT.
 * @param width - Largura do banner.
 * @param height - Altura do banner.
 * @param marginBottom - Margem inferior opcional.
 */
export const AdBannerFooterContainerDesktop: React.FC<
  AdBannerFooterContainerProps
> = ({ slotId, adUnit, width, height, marginBottom = 0 }) => {
  return (
    <Container style={{ marginBottom }}>
      <GoogleBannerAd slotId={slotId} adUnitPath={adUnit} sizes={[[970, 90]]} />
    </Container>
  );
};
